module.exports = __webpack_public_path__ + "img/adult.2eae9dd2.svg";